<script>
    import { Timestamp} from "firebase/firestore";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Button from "../ui/Button.svelte";
    import ButtonAdd from "../ui/ButtonAdd.svelte";
    import Fa from "svelte-fa";
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import Timeframe from "../dateRangePicker/Timeframe.svelte";
    import ToggleSwitch from "../ToggleSwitch.svelte";
    import Help from "../ui/Help.svelte";
    import Warning from "../ui/Warning.svelte";
    import { daysBetweenDates } from "../../utils/utils";
    import DatePicker from "../datePicker/DatePicker.svelte";

    export let blocked;
    const dispatch = createEventDispatcher();

    $: valid = newCard.stampCount && newCard.stampCount > 0 && newCard.name && newCard.start && newCard.end && newCard.redeemableUntil && newCard.redeemableUntil?.getTime() >= newCard.end?.getTime();
    $: stampsPerWeek = (newCard.stampCount > 0 && newCard.start && newCard.end)?Math.round(newCard.stampCount/(daysBetweenDates(newCard.start, newCard.end)+1)*7):undefined;

    let newCard;
    let open = false;

    reset();

    function confirm() {
        console.log({...newCard});
        newCard.start = Timestamp.fromDate(newCard.start);
        newCard.end = Timestamp.fromDate(newCard.end);
        newCard.redeemableUntil = Timestamp.fromDate(newCard.redeemableUntil);
        dispatch("addCard", {data: newCard});
        newCard = {
            stampCount: 10,
            autoRenewal: true
        };
        open = false;
    }

    function reset() {
        newCard = {
            stampCount: 10,
            autoRenewal: true
        };
    }

    function cancel() {
        reset();
        open = false;
    }
</script>


<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Stempelkarte hinzufügen</DialogTitle>
        <DialogDescription class="dialog-description">
            Lege eine Stempelkarte an. Sobald die Angaben vollständig sind und der Gültigkeitszeitraum beginnt können Nutzer sie sehen und benutzen.
        </DialogDescription>

        <form on:submit|preventDefault={confirm}>
            <h3>Karteneinstellungen</h3>
            <label>Name
                <input bind:value={newCard.name} type="text">
            </label>
            <label>Stempelanzahl
                <select bind:value={newCard.stampCount}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                </select>
            </label>
            <h3>Gültigkeitszeitraum</h3>
            <Timeframe bind:blocked bind:start={newCard.start} bind:end={newCard.end} minimumDuration=7 />
            Einlösbar bis <DatePicker bind:date={newCard.redeemableUntil} min={newCard.end}/>
            <div class="auto-renew">
                <ToggleSwitch label="Karte automatisch verlängern" bind:checked={newCard.autoRenewal}/>
                <Help>
                    Wenn diese Option aktiv ist, wird vor dem Ablaufen der Karte das Ende immer wieder um eine Woche verlängert. Dies geschieht solange bis eine andere Karte beginnt, oder du die Option deaktivierst.
                </Help>
            </div>
            {#if stampsPerWeek && stampsPerWeek > 1}
                <Warning>
                    Deine Kunden müssten um eine Belohnung zu erhalten mehr als einen Stempel pro Woche sammeln {#if stampsPerWeek > 2}(aktuell rund {stampsPerWeek} pro Woche){/if}. Wir empfehlen einen längeren Gültigkeitszeitraum einzustellen.
                </Warning>
            {/if}
            <!-- <h3>Gültigkeitszeitraum</h3>
            <Timeframe bind:blocked bind:start={newCard.start} bind:end={newCard.end} minimumDuration=7 />
            Einlösbar bis <DatePicker bind:date={newCard.redeemableUntil} min={newCard.end}/>
            <div class="auto-renew">
                <ToggleSwitch label="Karte automatisch verlängern" bind:checked={newCard.autoRenewal}/>
                <Help>
                    Wenn diese Option aktiv ist, wird vor dem Ablaufen der Karte das Ende immer wieder um eine Woche verlängert. Dies geschieht solange bis eine andere Karte beginnt, oder du die Option deaktivierst.
                </Help>
            </div>
            {#if stampsPerWeek && stampsPerWeek > 1}
                <Warning>
                    Deine Kunden müssten um eine Belohnung zu erhalten mehr als einen Stempel pro Woche sammeln {#if stampsPerWeek > 2}(aktuell rund {stampsPerWeek} pro Woche){/if}. Wir empfehlen einen längeren Gültigkeitszeitraum einzustellen.
                </Warning>
            {/if} -->
            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button intent="primary" type="submit" disabled={!valid}>
                    Hinzufügen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<ButtonAdd on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
</ButtonAdd>

<style>
    .auto-renew {
        display: flex;
        align-items: center;
    }
</style>